module.exports = __webpack_public_path__ + "officialStatic/img/p5.623d34c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/p5.png
// module id = 1QhM
// module chunks = 0